import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Alert, Col, Row, Tab, } from 'react-bootstrap';
import AppHeader from './components/appHeader';
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import './App.css';
import './spacers.css'
import LoginPage from './containers/loginPage';
import ComponentPage from './components/componentPage';
import NavBar from './components/navBar';

const Tabs = [{
  eventKey: 'permanent-licenses',
  name: "Online permanent licenses",
}, {
  eventKey: 'temporary-licenses',
  name: "Online temporary licenses",
}, {
  eventKey: 'trial-licenses',
  name: "Trial licenses",
}, {
  eventKey: 'offline-licenses',
  name: "Offline licenses",
}, {
  eventKey: 'clients',
  name: "Clients",
// }, {
//   eventKey: 'product-releases',
//   name: "Product releases",
}, {
  eventKey: 'history',
  name: "History",
}, {
  eventKey: 'admin-history',
  name: 'Admin history',
}, {
  eventKey: 'ai-accounts',
  name: 'AI accounts'
}, {
  eventKey: 'features',
  name: 'Features'
}, {
  eventKey: 'device-features',
  name: 'Device features'
}, {
  eventKey: 'trial-settings',
  name: 'Trial settings',
}, {
  eventKey: 'web-viewer-feature-packages',
  name: 'Web viewer feature packages'
}, {
  eventKey: 'web-viewer-servers',
  name: 'Web viewer servers'
}, {
  eventKey: 'web-viewer-licenses',
  name: 'Web viewer licenses'
}, {
  eventKey: 'ban',
  name: 'Banned devices'
}];

class App extends Component {
  constructor(props) {
    super(props);
    this.uriBeforeLogin = '/';
    this.state = {
      eventKey: Tabs[0].eventKey,
    };
  }

  static getDerivedStateFromProps(props, state) {
    const { pathname } = props.history.location;
    const eventKey = pathname.slice(1, pathname.length) || 'permanent-license';
    if (eventKey === state.eventKey) return null;
    return { ...state, eventKey };
  }

  checkAuthAndRedirect() {
    const { inSession, history } = this.props;
    if (history.location.pathname !== '/login') {
      const { location } = history;
      this.uriBeforeLogin = `${location.pathname}${location.search}`;
      if (!inSession) {
        history.replace('/login');
        return;
      }
    } else if ( inSession && this.uriBeforeLogin)
      history.replace(this.uriBeforeLogin);
  }

  componentDidMount() {
    this.checkAuthAndRedirect();
  }

  componentDidUpdate() {
    this.checkAuthAndRedirect();
  }

  render() {
    const { inSession } = this.props;
    return (
      <div className="App">
        { (process.env.NODE_ENV && process.env.NODE_ENV === 'production' && window.location.protocol !== 'https:') ?
          <Alert bsStyle="danger" bsClass="main-alert alert">
            You use Admin tool with http protocol. Some functionality may not be available. Use the https Admin tool!
          </Alert> :
          <React.Fragment/>
        }
        <AppHeader Tabs={Tabs}/>
        <Tab.Container id="app-main-menu-tabs" defaultActiveKey={this.state.eventKey}>
          <div className="container">
            <Row className="clearfix">
              {inSession && (
                <Col className="hide-on-991" md={1}>
                  <NavBar tabs={Tabs}/>
                </Col>
              )}
              <Col md={11}>
                <Switch>
                  <Route exact path="/login" component={(requestData) => {
                    return <LoginPage requestData={requestData}/>
                  }}/>
                  {Tabs.map((tab) => {
                    return (
                      <Route key={tab.eventKey} exact path={`/${tab.eventKey}`} component={(requestData) => (
                        <ComponentPage
                          tabs={Tabs}
                          tab={tab.eventKey}
                          requestData={requestData}/>
                      )}/>
                    );
                  })}
                  <Redirect to={Tabs[0].eventKey}/>
                </Switch>
              </Col>
            </Row>
          </div>
        </Tab.Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  inSession: state.auth.inSession,
});

export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js